<template lang="pug">
  .profile-page-form
    .profile-page-form__section-container
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Общая информация родителя (законного представителя ребенка)
          label.checkbox(
            v-if="status === 2"
          )
            input.checkbox__input(
              type="checkbox"
              @change="onChangeAcceptValue($event, 'parent_1')"
              :checked="acceptList.indexOf('parent_1') > -1"
            )
            .checkbox__icon
        .profile-section__body
          info(
            :fields="dataProfile.main"
            :request-data="requestData"
          )
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Контакты
          label.checkbox(
            v-if="status === 2"
          )
            input.checkbox__input(
              type="checkbox"
              @change="onChangeAcceptValue($event, 'parent_2')"
              :checked="acceptList.indexOf('parent_2') > -1"
            )
            .checkbox__icon

        .profile-section__body
          info(
            :fields="dataProfile.contacts"
            :request-data="requestData"
          )
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Документы
          label.checkbox(
            v-if="status === 2"
          )
            input.checkbox__input(
              type="checkbox"
              @change="onChangeAcceptValue($event, 'parent_3')"
              :checked="acceptList.indexOf('parent_3') > -1"
            )
            .checkbox__icon
        .profile-section__body
          info(
            :fields="dataProfile.docs"
            :request-data="requestData"
          )
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Адрес проживания
          label.checkbox(
            v-if="status === 2"
          )
            input.checkbox__input(
              type="checkbox"
              @change="onChangeAcceptValue($event, 'parent_4')"
              :checked="acceptList.indexOf('parent_4') > -1"
            )
            .checkbox__icon
        .profile-section__body
          info(
            :fields="dataProfile.address"
            :request-data="requestData.actual_address"
          )
</template>
<script>
import Info from "../components/Info";
import Awards from "../components/Awards";

export default {
  name: "InfoParent",
  components: {
    Awards,
    Info
  },
  props: [
    "dataProfile",
    "requestData",
    "status",
    "onChangeAcceptValue",
    "acceptList"
  ],
  data() {
    return {
      showErrorInfo: false
    };
  }
};
</script>
